import React from 'react';

import Link from '~/shared/components/Link/Link';
import { Text } from '~/shared/components/Text/Text';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';

import { Highlight } from './components/Highlight';
import ownStyles from './suggestedCategories.module.css';

import rootStyles from '../SearchDialogContent/searchDialogContent.module.css';

export interface ISearchResultItem {
	text: string;
	link: string;
}

type Props = {
	results: ISearchResultItem[];
	searchWords: string[];
};

const HighlightedComponent = ({ children }: any) => (
	<Text
		as="mark"
		variant="suggestion"
		style={{ backgroundColor: 'inherit', fontWeight: '800' }}
	>
		{children}
	</Text>
);

const NonHighlightedComponent = ({ children }: any) => (
	<Text
		as="span"
		variant="suggestion"
	>
		{children}
	</Text>
);

export const SearchSuggestionsResults: React.FC<Props> = ({ results, searchWords }) => {
	const { translate } = useTranslation();

	if (!results.length) {
		return null;
	}

	return (
		<div className={rootStyles.quickLinksArea}>
			<Text
				className={rootStyles.listLabel}
				as="h3"
				variant="bodySm"
				id="suggested-categories"
			>
				{translate('search.suggested-categories')}
			</Text>
			<ol
				className={ownStyles.list}
				aria-labelledby="suggested-categories"
			>
				{results.map((item, index) => (
					<li key={index}>
						<Link href={item.link}>
							<Highlight
								text={item.text}
								searchWords={searchWords}
								highlightedComponent={HighlightedComponent}
								nonHighlightedComponent={NonHighlightedComponent}
							/>
						</Link>
					</li>
				))}
			</ol>
		</div>
	);
};
